<template>
  <div>
    <b-navbar
      toggleable="lg"
      type="faded"
      fixed="top"
      class="py-0 navbar-customer"
    >
      <b-container>
        <b-navbar-brand :href="$store.state.customer_link" class="py-2">
          <img :src="logo" alt="Logo" style="max-height: 40px" v-if="logo" />
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse">
          <font-awesome-icon :icon="['far', 'bars']"></font-awesome-icon>
        </b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item
              :to="{ name: 'index' }"
              :class="{
                active: $route.name == 'index',
                'item-menu-text': true,
              }"
              >{{
                customer == "clab" ? "Mis inversiones" : "Mis Bienes"
              }}</b-nav-item
            >
            <b-nav-item
              v-if="opportunitiesPermission"
              :to="{ name: 'opportunities' }"
              :class="{
                active: $route.name == 'opportunities',
                'item-menu-text': true,
              }"
              >Oportunidades</b-nav-item
            >
            <b-nav-item
              v-if="country == 1 && showQuote"
              :to="{ name: 'quote' }"
              :class="{
                active: $route.name == 'quote',
                'item-menu-text': true,
              }"
              :active="$route.name == 'information'"
              >{{ customer == "clab" ? "Simular" : "Cotizar" }}</b-nav-item
            >
            <b-nav-item
              v-if="country == 1 && showQuotes"
              :to="{ name: 'myquotes' }"
              :class="{
                active: $route.name == 'myquotes',
                'item-menu-text': true,
              }"
            >
              {{ customer == "clab" ? "Simulaciones" : "Cotizaciones" }}
            </b-nav-item>
            <b-nav-item
              v-if="showMyData"
              :to="{ name: 'information' }"
              :class="{
                active: $route.name == 'information',
                'item-menu-text': true,
              }"
              :active="$route.name == 'information'"
              >Mis Datos</b-nav-item
            >
            <b-nav-item @click="logout">Cerrar sesión</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
  </div>
</template>
<script>
export default {
  name: "NavBar",
  methods: {
    logout() {
      this.$auth.logout({
        redirect: `/app/${this.customer}/login`,
        success: function (msg) {
          console.error("LOGIN:", msg);
        },
      });
    },
  },
  computed: {
    customer() {
      return this.$store.getters.getCustomer;
    },
    logo() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.logo_1_url
        : null;
    },
    country() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.country
        : 1;
    },
    opportunitiesPermission() {
      if (this.$store.getters.getCustomerData) {
        return this.$store.getters.getCustomerData.products.find(
          (product) => product.name == "Oportunidades"
        ) && this.$store.getters.getCustomerData.show_opportunity
          ? true
          : false;
      } else {
        return false;
      }
    },
    showQuote() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.show_quote
        : false;
    },
    showQuotes() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.show_quotes
        : false;
    },
    showMyData() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.show_my_data
        : false;
    },
  },
};
</script>
